import { Paper, useMediaQuery, useTheme } from '@mui/material';
import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: 240,
    },
  },
  wrapper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      maxWidth: 1060,
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      maxWidth: 1400,
    },
  },
  paper: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  noMargin: { marginBottom: '0 !important' },
}));

export interface ContainerProps {
  children?: React.ReactNode;
  disableMargin?: boolean;
  paper?: boolean;
}

const Container = ({
  paper = true,
  disableMargin = false,
  children,
}: ContainerProps) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Link id="top" to="#top" style={{ textDecoration: 'none' }} />
      <div className={classes.root}>
        <div
          className={classNames(
            disableMargin && classes.noMargin,
            classes.wrapper,
          )}
        >
          {!paper || isSmall ? (
            children
          ) : (
            <Paper elevation={0} className={classes.paper}>
              {children}
            </Paper>
          )}
        </div>
      </div>
    </>
  );
};

export default Container;
